import { Injectable } from '@angular/core';
import { Router } from '@angular/router'; 
import { AuthService } from '@auth0/auth0-angular'; 
import { PatientEngagementService } from '../../modules/myPrimeRx/services/patient-engagement.service';
import { PeAuthService } from '../../core/services/auth.service';
import { StateService } from '../../modules/myPrimeRx/services/history.state.service';
import { constant } from './../../constants/app.constants'
import { IdentifierTypeEnum } from '../../modules/SecurePatientCommunication/models/chat.enum';
import { takeUntil } from 'rxjs/operators';
import { firstValueFrom, Subject } from 'rxjs';
import { PatientProfilePictureModel } from '../../modules/myPrimeRx/models/UserOTP.model';
@Injectable({
    providedIn: 'root'
})

export class SMSservice { 
    maskedPhoneNumber:string = "";
    elinkData:any;
    isGuestUser:boolean= false;
    elinkParams:any;
    avatarUrl: any;
    phInfo:any;
    rxHistoryData:any;
    elinkDataString:any;
    dashbaordCounts: any = [];
    unsubscribe$: Subject<void> = new Subject();
    private lastCountsFetchTime = 0;
    private lastCountsResult: any = null;
    private countsCooldownMs = 10000; // 10 second cooldown between API calls
    private countsInFlight: Promise<any> | null = null; // deduplicate concurrent calls
    constructor(private _router: Router,
        public auth:AuthService,
        public peAuthService: PeAuthService,
        public _patientEngagementService:PatientEngagementService,
        private stateService: StateService){
            this.refreshLocalData();
        }

    refreshLocalData() {
        const paramsRaw = localStorage.getItem('paramsData');
        this.elinkParams = (paramsRaw && paramsRaw !== 'undefined') ? JSON.parse(paramsRaw) : null;

        const elinkRaw = localStorage.getItem('eLinkData');
        this.elinkData = (elinkRaw && elinkRaw !== 'undefined') ? JSON.parse(elinkRaw) : {};

        const guestRaw = localStorage.getItem('IsGuestUser');
        this.isGuestUser = (guestRaw && guestRaw !== 'undefined') ? JSON.parse(guestRaw) : false;
    }

    async initSendOTP(){
        this.refreshLocalData();
        try{
            const maskedPart = 'xxx-xxx-';
            const lastPart = this.elinkData?.PatientPhoneNo.slice(6);
            this.maskedPhoneNumber = maskedPart + lastPart;
            const payload: any = {
                "MessageTo": this.elinkData?.PatientPhoneNo,
                "npi": this.elinkParams?.npi
            }
            await firstValueFrom(this._patientEngagementService.postSendOTP(payload));
        } catch (error) {
            // Handle errors here
        }
    }

    async patientPharmacyInfo(){
        this.refreshLocalData();

        try{
            console.log("sms service => patientPharmacyInfo above if case",this.elinkData,this.elinkParams)
            if (this.elinkData && this.elinkParams) {
                const pharmObject: any = {
                    "npiData": this.elinkParams?.npi,
                    "phoneNumber": this.elinkData?.PatientPhoneNo,
                    "patientNo": this.elinkData?.EntityId,
                    "pharmacyName": this.elinkData?.PharmacyName
                }

                const result = await firstValueFrom(
                    this._patientEngagementService.postPatientPharmacyInfo(pharmObject)
                );
                console.log("sms service => patientPharmacyInfo result",result)
                // Proceed to pharmacyInfo regardless — new patients may not have records yet
                await this.pharmacyInfo();
            }
            else
            {
                console.log("sms service => patientPharmacyInfo else case: missing elinkData or elinkParams, navigating to dashboard")
                this._router.navigate(['/PendingPayments']);
            }
        } catch (error) {
            console.log("sms service => patientPharmacyInfo catch case", error)
            // Don't logout on API failure — navigate to dashboard instead
            await this.pharmacyInfo();
        }
    }

    async pharmacyInfo(){
        this.phInfo = {
            "pharmacyNpi": this.elinkParams?.npi,
            "patientId": this.elinkData?.EntityId
        }
        try {
            console.log("sms service => pharmacyInfo above firstValueFrom case",this.phInfo)
                const cached = localStorage.getItem('PharmacyInfo');
                let pharmacyInfo = cached ? JSON.parse(cached) : null;
                if (!pharmacyInfo)
                    {
                        const result = await firstValueFrom(
                            this._patientEngagementService.postPharmacyInfo(this.phInfo)
                        );
                        if (result) {
                            pharmacyInfo = result;
                        localStorage.setItem('PharmacyInfo', JSON.stringify(result));
                    }
                }
                if (pharmacyInfo)
                    {
                        console.log("sms service => pharmacyInfo success case",pharmacyInfo)
                        console.log("sms service => elinks case",this.elinkData)
                        await this.handleElinkResponse(this.elinkData);
                        // Pre-fetch dashboard counts in background so they're cached when dashboard loads
                        this.prefetchDashboardCounts();
                        this._router.navigate(['/PendingPayments']);
                    }
                else
                {
                    console.log("sms service => pharmacyInfo: no pharmacy info found, navigating to dashboard")
                    this.prefetchDashboardCounts();
                    this._router.navigate(['/PendingPayments']);
                }
        } catch (error) {
            console.log("sms service => pharmacyInfo catch case", error)
            // Navigate to dashboard instead of logging out — let dashboard handle missing data
            this.prefetchDashboardCounts();
            this._router.navigate(['/PendingPayments']);
        }
    }
    setAvatarUrl(gender: string) {
		if (gender?.toLowerCase() === 'male') {
        this.avatarUrl = '/assets/images/male_pic.png';
      } else if (gender?.toLowerCase() === 'female') {
        this.avatarUrl = '/assets/images/female_pic.png';
      } else {
        this.avatarUrl = '/assets/images/dp_pic.png';
		}
	}
    async handleElinkResponse(response: any) {
        const elinkMapping: { [key: string]: string } = {
            'RefillDue': constant.REFILLS_DUE,
            'Subscription': constant.SUBSCRIPTION,
            'UnSubscribe': constant.UNSUBSCRIBE,
            'General': constant.GENERAL,
            'Birthday': constant.BIRTHDAY,
            'PickUpAlert': constant.READY_TO_DISPENSE,
            'NewErx': constant.NEW_PRESSCRIPTION,
            'MobilePayment': constant.PENDING_PAYMENTS,
            'Chat': constant.CHAT
        };

        const activeSection = elinkMapping[response.ElinkType];
        if (activeSection) {
            await this.stateService.setActiveSection(activeSection);
        } else {
            console.error('Unknown ElinkType:', response.ElinkType);
        }
    }
    async getCounts() {
        // await this.getDashboardgetPharmaInfo();
        this.dashbaordCounts  = await this.getDashboardCounts();
        if(this.dashbaordCounts) {
            const DboardCounts = {
            "Pending_Payments": this.dashbaordCounts?.pendingPaymentsCount,
            "My_Meds": this.dashbaordCounts?.rxHistoryCount,
            "Ready_to_Dispense": this.dashbaordCounts?.readyForPickupCount,
            "Refills_Due": this.dashbaordCounts?.refillDueRxCount,
            "New_Prescription": this.dashbaordCounts?.newErxCount 
            }
            //localStorage.setItem('DboardCounts', JSON.stringify(DboardCounts)); 
        }
    }
    getDashboardCounts(): Promise<any> {
        // If called within cooldown window, return cached raw result
        const now = Date.now();
        if (now - this.lastCountsFetchTime < this.countsCooldownMs && this.lastCountsResult) {
            return Promise.resolve(this.lastCountsResult);
        }

        // If a fetch is already in progress, return the same promise (deduplicates concurrent calls)
        if (this.countsInFlight) {
            return this.countsInFlight;
        }

        this.refreshLocalData();
        this.phInfo = {
            "pharmacyNpi": this.elinkParams?.npi,
            "patientId": this.elinkData?.EntityId
        }

        this.countsInFlight = this._patientEngagementService.dashboardCounts(this.phInfo).toPromise()
            .then(result => {
                if (result) {
                    this.lastCountsFetchTime = Date.now();
                    this.lastCountsResult = result;
                }
                this.countsInFlight = null;
                return result;
            })
            .catch(error => {
                this.countsInFlight = null;
                return undefined;
            });

        return this.countsInFlight;
    }

    /** Fire-and-forget: pre-fetch counts and cache them so dashboard loads instantly */
    prefetchDashboardCounts() {
        this.getDashboardCounts().then(result => {
            if (result) {
                const counts = {
                    "Pending_Payments": result?.pendingPaymentsCount,
                    "My_Meds": result?.rxHistoryCount,
                    "Ready_to_Dispense": result?.readyForPickupCount,
                    "Refills_Due": result?.refillDueRxCount,
                    "New_Prescription": result?.newErxCount,
                    "patientName": result?.patientName,
                    "patDOB": result?.patDOB
                };
                localStorage.setItem('DboardCounts', JSON.stringify(counts));
            }
        }).catch(() => {});
    }

    async getDashboardgetPharmaInfo() {
        this.phInfo = {
            "pharmacyNpi": this.elinkParams?.npi,
            "patientId": this.elinkData?.EntityId
        }
        try {
            const result = await this._patientEngagementService.postPharmacyInfo(this.phInfo).toPromise();
            if(result){
                localStorage.setItem('PharmacyInfo', JSON.stringify(result));
            } 
        } catch (error) {
            // Handle error appropriately
        }
    }

    async getPatientProfile() {
         const pharmacyInfo = JSON.parse(localStorage.getItem('PharmacyInfo') as string);
        this.phInfo = {
            "pharmacyNpi": this.elinkParams?.npi,
            "patientId": this.elinkData?.EntityId,
            "TenantId": pharmacyInfo?.tenantId
        }
        try {
            
            const result = await this._patientEngagementService.dashboardPatientInfo(this.phInfo).toPromise();
            if(result){
				return result;
			}
        } catch (error) {
            // Handle error appropriately
        }
    }

    async savePatientProfile(payload: any) {
        try {
            const result = await this._patientEngagementService.savePatientProfileInfo(payload).toPromise();
            if(result){
        return result;
    }
        } catch (error) {
            // Handle error appropriately
        }
    }

    async deletePatientProfile(payload: any) {
        try {
            const result = await this._patientEngagementService.deletePatientProfileInfo(payload).toPromise();
            if(result){
        return result;
    }
        } catch (error) {
            // Handle error appropriately
        }
    }
    async saveProfilePictureId(payload: PatientProfilePictureModel) {
        try {
            console.log("sms service => saveProfilePictureId",payload);
            const result = await this._patientEngagementService.saveProfilePictureId(payload).toPromise();
            if(result){
                return result;
            }
        } catch (error) {
            // Handle error appropriately
        }
    }

    async getMyMedsHistory(payload:any) {
        try {
            const result = await this._patientEngagementService.myMedsHistory(payload).toPromise();
            if(result){
				return result;
			}
        } catch (error) {
            // Handle error appropriately
        }
    }
    
    async getReadyForPickup(payload:any) {
        try {
            const result = await this._patientEngagementService.readyForPickup(payload).toPromise();
            if(result){
				return result;
			}
        } catch (error) {
            // Handle error appropriately
        }
    }

    async getNewErxs(payload:any) {
        try {
            const result = await this._patientEngagementService.newErxs(payload).toPromise();
            if(result){
				return result;
			}
        } catch (error) {
            // Handle error appropriately
        }
    }

    async getRefillsDue(payload:any) {
        try {
            const result = await this._patientEngagementService.refillsDue(payload).toPromise();
            if(result){
				return result;
			}
        } catch (error) {
            // Handle error appropriately
        }
    }

    async getAddToRefillQueue(payload:any) {
        try {
            const result = await this._patientEngagementService.addToRefillQueue(payload).toPromise();
            if(result){
				return result;
			}
        } catch (error) {
            // Handle error appropriately
        }
    }

    async postTransaction(payload:any) {
        try {
            const result = await this._patientEngagementService.getTransaction(payload).toPromise();
            if(result){
				return result;
			}
        } catch (error) {
            // Handle error appropriately
        }
    }

    async postUpdateSubscription(payload:any) {
        try {
            const result = await this._patientEngagementService.updateSubscription(payload).toPromise();
            if(result){
				return result;
			}
        } catch (error) {
            // Handle error appropriately
        }
    }

    async checkUserDetailEmail(payload:any) {
        try {
            const result = await this._patientEngagementService.postUserDetailEmail(payload).toPromise();
            if(result){
				return result;
			}
        } catch (error) {
            // Handle error appropriately
        }
    }

    async getMessageUnreadCount() {
        this.refreshLocalData();
        const payload = {
            "Sender": {
                "Identifier": this.elinkParams?.npi,
                "IdentifierType": IdentifierTypeEnum.NPI
                },
            "Recipient": {
                "Identifier": ""+this.elinkData?.EntityId,
                "IdentifierType": IdentifierTypeEnum.PATIENT 
                }
        }
        try {
            const result = await this._patientEngagementService.postMessageUnreadCount(payload).toPromise(); 
            if (result) {  
                return result;
            }
            
        } catch (error) {
            // Handle error appropriately
        }
    }
          async uploadImagesInChatHist(payload:any) {
        try {
            const result = await this._patientEngagementService.uploadImage(payload).toPromise();
            if(result){
				return result;
			}
        } catch (error) {
            // Handle error appropriately
        }
    }
    
}